import {
  useMemo,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getStorages, resetStorages } from 'store/storages/actions';
import {
  getStorages as getStoragesSelector,
  getStoragesLoadingState,
  getStoragesOptions,
} from 'store/storages/selectors';
import useDebounce from 'library/hooks/use-debounce';
import { getLabelMap } from 'library/helpers/text';

const useCategoryList = (skip = true, defaultSnapshot = {}, resetOnUnmount = true) => {
  const [query, onQueryChange] = useState('');
  const debouncedQuery = useDebounce(query, 300);
  const dispatch = useDispatch();
  const data = useSelector(getStoragesSelector);
  const isLoading = useSelector(getStoragesLoadingState);
  const options = useSelector(getStoragesOptions);
  const labelMapSnapshot = useRef({});

  useEffect(() => {
    if (!skip) {
      dispatch(getStorages({ name: debouncedQuery }));
    } else if(skip && data.length) {
      labelMapSnapshot.current = {};

      if (data.length && resetOnUnmount) {
        dispatch(resetStorages());
      }

      if (debouncedQuery) {
        onQueryChange('');
      }
    }
  }, [debouncedQuery, skip]);

  useEffect(() => {
    return () => {
      if(resetOnUnmount) {
        dispatch(resetStorages());
      }
    };
  }, []);

  return useMemo(() => {
    const labelMap = getLabelMap(data, {
      ...defaultSnapshot,
      ...labelMapSnapshot.current,
    });

    labelMapSnapshot.current = labelMap;

    return {
      data,
      isLoading,
      options,
      labelMap,
      onQueryChange,
    };
  }, [data, defaultSnapshot]);
};

export default useCategoryList;
